/* eslint-disable no-param-reassign */
import {
  call,
  put,
  CallEffect,
  PutEffect,
  SelectEffect,
} from 'redux-saga/effects';
import { PayloadAction, AnyAction } from '@reduxjs/toolkit';

import { buildApiUrl } from 'environment';
import fetchHelper, { isOkHttpResponse } from 'services/apiService';
import type { HttpResponse } from 'services/apiService';
import {
  createErrorId,
  createBackendErrorMessage,
  createNetworkErrorMessage,
} from 'services/errorService';
import type { StatusCounts } from 'state/shared/createStatusCounts';
import {
  notificationsActions,
  NotificationSeverity,
} from 'state/notifications';

import type { SendVerificationEmailResponseBody } from '../../shared/apiTypes';
import { signUpStepsActions } from '../signUpStepsSlice';
import type { SendVerificationEmailDto } from '../signUpStepsTypes';

const { SEND_VERIFICATION_EMAIL_SUCCESS, SEND_VERIFICATION_EMAIL_FAILURE } =
  signUpStepsActions;

const { ADD_NOTIFICATION } = notificationsActions;

export default function* sendVerificationEmail(
  statusCounts: StatusCounts,
  action: PayloadAction<SendVerificationEmailDto>
): Generator<
  CallEffect<AnyAction> | PutEffect<AnyAction> | SelectEffect,
  void,
  HttpResponse<SendVerificationEmailResponseBody>
> {
  const {
    payload: { username },
  } = action;
  const { type: errorActionType } = SEND_VERIFICATION_EMAIL_FAILURE;

  try {
    const response = yield call(
      fetchHelper.post,
      // TODO: uncomment once email sending is sorted out
      // buildApiUrl('sendVerificationEmail'),
      // TODO: remove once email sending is sorted out
      buildApiUrl('generateVerificationToken'),
      { username }
    );
    if (
      isOkHttpResponse<typeof response, SendVerificationEmailResponseBody>(
        response,
        response.parsedBody
      )
    ) {
      // TODO: uncomment once email sending is sorted out
      // yield put(SEND_VERIFICATION_EMAIL_SUCCESS());
      const { verificationToken } = response.parsedBody;
      yield put(SEND_VERIFICATION_EMAIL_SUCCESS({ verificationToken }));
      // TODO: uncomment once email sending is sorted out
      // const { type: actionType } = SEND_VERIFICATION_EMAIL_SUCCESS;
      // yield put(
      // ADD_NOTIFICATION({
      // id: `${actionType}#${(statusCounts[actionType] += 1)}`,
      // // TODO: move this message to const
      // message: 'Verification email sent!',
      // notificationSeverity: NotificationSeverity.success,
      // })
      // );
    } else if (response) {
      // backend error
      yield put(
        SEND_VERIFICATION_EMAIL_FAILURE({
          id: createErrorId(
            errorActionType,
            (statusCounts[errorActionType] += 1)
          ),
          error: createBackendErrorMessage(response),
        })
      );
    }
  } catch (error) {
    // network error
    if (error instanceof Error) {
      yield put(
        SEND_VERIFICATION_EMAIL_FAILURE({
          id: createErrorId(
            errorActionType,
            (statusCounts[errorActionType] += 1)
          ),
          error: createNetworkErrorMessage(error),
        })
      );
    }
  }
}
